/* "Which Step Ones are right for me?" cards, ported from
   BoxerBriefSelectionSection.tsx. Shop buttons dispatch the same cancelable
   s1:product-change event the product nav uses: consumed -> the s1-pdp
   swaps product in-page and we scroll back up to it (SPA behaviour);
   unconsumed (no PDP on the page) -> plain navigation. */

class S1Selection extends HTMLElement {
  connectedCallback() {
    if (this._initialized) {
      if (this._check) {
        this._abort = new AbortController();
        window.addEventListener('resize', this._check, { signal: this._abort.signal });
        this._check();
      }
      return;
    }
    this._initialized = true;

    const strip = this.querySelector('[data-s1-sel-strip]');
    const prev = this.querySelector('[data-s1-sel-prev]');
    const next = this.querySelector('[data-s1-sel-next]');

    if (strip && prev && next) {
      const check = () => {
        prev.hidden = !(strip.scrollLeft > 0);
        next.hidden = !(strip.scrollLeft < strip.scrollWidth - strip.clientWidth - 5);
      };
      strip.addEventListener('scroll', check, { passive: true });
      this._check = check;
      this._abort = new AbortController();
      window.addEventListener('resize', check, { signal: this._abort.signal });
      check();
      setTimeout(check, 1000);
    }

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-s1-sel-prev]')) return this.scrollStrip(-1);
      if (e.target.closest('[data-s1-sel-next]')) return this.scrollStrip(1);

      const shop = e.target.closest('[data-s1-sel-shop]');
      if (shop) {
        const detail = { url: shop.dataset.url };
        if (shop.dataset.collection) detail.collection = shop.dataset.collection;
        const consumed = !document.dispatchEvent(new CustomEvent('s1:product-change', {
          cancelable: true,
          detail,
        }));
        if (consumed) {
          /* a PDP on the page took over: block the anchor's navigation and
             scroll back up. Position-based scroll survives the section swap;
             the new s1-pdp runs a corrective pass on connect (flag below). */
          e.preventDefault();
          window.__s1PdpScrollAfterSwitch = true;
          const pdp = document.querySelector('s1-pdp');
          if (pdp) {
            const margin = parseFloat(getComputedStyle(pdp).scrollMarginTop) || 0;
            const top = pdp.getBoundingClientRect().top + window.scrollY - margin;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }
        /* not consumed (no PDP on this page): the anchor navigates natively */
      }
    });
  }

  disconnectedCallback() {
    if (this._abort) this._abort.abort();
  }

  scrollStrip(dir) {
    const strip = this.querySelector('[data-s1-sel-strip]');
    if (strip) strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
  }
}

if (!customElements.get('s1-selection')) customElements.define('s1-selection', S1Selection);
